import { Component, OnInit, NgZone } from '@angular/core';
declare var $: any;
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl } from '@angular/forms';
import { TranslateService } from '../../../_services/translate.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '../../../_services/api.service';
import { first } from 'rxjs/operators';
import { AnpiService } from '../../../_services/anpi-code.service';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Location } from '@angular/common';
import AOS from 'aos';
import 'aos/dist/aos.css';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {
  isSubmitted = false;
  public contactForm: FormGroup;
  response: any;
  accountDetails: any;
  constructor(private translate: TranslateService,
    private formBuilder: FormBuilder,
    private api: ApiService,
    private router: Router,
    private anpiService: AnpiService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    private ngzone: NgZone,
    private location: Location) {}

  ngOnInit() {
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      console.log("39", this.accountDetails)
    }
    this.contactForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.pattern("^[A-Za-z][A-Za-z\\s]*$")]],
      email: ['', [Validators.required, Validators.email]],
      mobile: ['', [Validators.required, Validators.pattern("^[a-zA-Z0-9]+$"), Validators.minLength(8), Validators.maxLength(8)]],
      company_name: ['', [Validators.required, Validators.pattern("^[A-Za-z0-9][A-Za-z0-9\\s]*$")]],
      message: ['', [Validators.required]]
    });
    AOS.init({
      disable: function() {
        var maxWidth = 600;
        return window.innerWidth < maxWidth;
      }
    });
    if (this.accountDetails) {
      this.contactForm.controls['name'].setValue(this.accountDetails.first_name + " " + this.accountDetails.last_name);
      console.log(this.contactForm.controls['name'].value)
    }

  }
  onSubmit() {
    this.isSubmitted = true;
    if (this.contactForm.invalid) {
      return;
    }

    var data = this.contactForm.value;
    if (this.accountDetails) {
      if (this.accountDetails.current_user == 2) {
        data['user_id'] = this.accountDetails.employee_id;
      } else if (this.accountDetails.current_user == 1) {
        data['user_id'] = this.accountDetails.employer_id;
      }
    }

    console.log(data);
    this.ngxUiLoaderService.start();
    this.api.contactDetails(data).pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          this.isSubmitted = false;
          console.log("148 companyDetails:", res.results)
          if (res.status == 200) {
            this.contactForm.reset();
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });

          } else {
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }

        },
        error => {
          this.ngxUiLoaderService.stop();
          this.isSubmitted = false;
        });
    this.isSubmitted = false;

  }
  get f() {
    return this.contactForm.controls;
  }

}
